<div class="not-found-page-container">

  <div class="error-message-card-container">
    <mat-icon svgIcon="frowning-face" class="error-message-card-icon"></mat-icon>
    <h1 class="error-message-card-title">{{ title() | transloco }}</h1>
    <h2 class="error-message-card-subtitle">{{ subtitle() | transloco }}</h2>
    <span class="error-message-card-body">{{ body() | transloco }}</span>
  </div>

  <span class="go-back-text">
    <a routerLink="/" class="go-back-anchor">
      {{ 'globalError.goHome' | transloco }}
    </a>
    {{ 'globalError.consolation' | transloco }}
  </span>
</div>
